export default __webpack_public_path__ + "bfb4fb9fa4eb4b45be3dc12d189d2865.coffee";